import React from "react";
import DefaultLayout from "../../Layouts/DefaultLayout";
import { useStoreContext } from "../../Contexts/StoreContext";
import DefaultLayoutProfile from "../../Layouts/DefaultLayoutProfile";
import ProfileTitle from "./ProfileTitle";
import { useTranslation } from 'react-i18next';
import FormResetCredentials from "../../Components/Form/FormResetCredentials";

const ProfileResetCredentials = () => {
    const { t } = useTranslation();
    const pageTitle = t('profile.menu.reset_credentials');
    document.title = pageTitle;

    const { currentStore } = useStoreContext();

    return (
        <DefaultLayout showHeader={currentStore}>
            <DefaultLayoutProfile>

                <div className="flex flex-col gap-2 p-2">

                    <ProfileTitle>{ pageTitle }</ProfileTitle>

                    <div className="md:max-w-md">
                        <FormResetCredentials />
                    </div>

                </div>

            </DefaultLayoutProfile>
        </DefaultLayout>
    );
};

export default ProfileResetCredentials;